import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';

const Pagination = ({ itemsPerPage, totalItems, paginate }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPages, setCurrentPages] = useState([]);
    const [arrowLeft, setArrowLeft] = useState('hidden');
    const [arrowRight, setArrowRight] = useState('hidden');

    const setPage = () => {
        const pageNumbers = [];

        for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i += 1) {
            pageNumbers.push(i);
        }

        let indexOfLastPage;

        if (currentPage <= 6) {
            indexOfLastPage = 10;
        } else {
            indexOfLastPage =
                pageNumbers.length < currentPage + 4
                    ? pageNumbers.length
                    : currentPage + 4;
        }

        const indexOfFirstPage = indexOfLastPage - 10;

        paginate(currentPage);

        setCurrentPages(pageNumbers.slice(indexOfFirstPage, indexOfLastPage));

        setArrowLeft(currentPage === 1 ? 'hidden' : 'visible');

        setArrowRight(
            currentPage === pageNumbers.length ? 'hidden' : 'visible'
        );
    };

    useEffect(() => {
        setPage();
    }, [currentPage, totalItems]);

    return (
        <Container>
            <button
                type="button"
                style={{ visibility: arrowLeft }}
                onClick={() => setCurrentPage(currentPage - 1)}
            >
                ‹
            </button>
            <ul>
                {currentPages.map(number => (
                    <li key={String(number)}>
                        <button
                            type="button"
                            onClick={() => setCurrentPage(number)}
                            style={{
                                background:
                                    number === currentPage
                                        ? 'rgba(255,255,255,.1)'
                                        : '',
                            }}
                        >
                            {number}
                        </button>
                    </li>
                ))}
            </ul>
            <button
                type="button"
                style={{ visibility: arrowRight }}
                onClick={() => setCurrentPage(currentPage + 1)}
            >
                ›
            </button>
        </Container>
    );
};

Pagination.propTypes = {
    itemsPerPage: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
    paginate: PropTypes.func.isRequired,
};

export default Pagination;
